import React from "react";
import { Helmet } from "react-helmet";

function DefaultMeta() {
  const defaultTitle = "Clarity Cooperative";
  const defaultSiteName = window.location.origin;
  const defaultImageWidth = "1200";
  const defaultImageHeight = "628";

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{defaultTitle}</title>
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="allow-search" content="yes" />
      <meta name="googlebot" content="index,follow, noodp" />
      <meta name="yahooSeeker" content="index, follow" />
      <meta name="msnbot" content="index, follow" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=3" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="apple-mobile-web-app-title" content={defaultTitle} />

      {/* Chrome, Firefox OS and Opera */}
      <meta name="theme-color" content="#ffffff" />
      {/* Windows Phone */}
      <meta name="msapplication-navbutton-color" content="#ffffff" />
      {/* iOS Safari */}
      <meta name="apple-mobile-web-app-status-bar-style" content="#ffffff" />
      <meta name="original-source" content={defaultSiteName} />

      <meta property="og:type" content="website" />
      <meta property="og:image:width" content={defaultImageWidth} />
      <meta property="og:image:height" content={defaultImageHeight} />
      <meta property="og:image:site_name" content={defaultSiteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@claritycooprative" />
      <meta name="twitter:image:width" content={defaultImageWidth} />
      <meta name="twitter:image:height" content={defaultImageHeight} />
      <link rel="canonical" href={window?.location?.href} />
    </Helmet>
  );
}

export default DefaultMeta;
